import { FaArrowCircleUp } from "react-icons/fa";
import { motion } from "framer-motion";
import "./PageNotFound.css";

const PageNotFound = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 50,
        delay: 0.5,
        staggerChildren: 0.3,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 50,
      },
    },
  };

  const iframeVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 50,
        delay: 0.8,
      },
    },
  };

  return (
    <div className="page-not-found">
      <motion.div
        className="content-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1
          className="title"
          variants={textVariants}
        >
          Use Navbar
        </motion.h1>
        <motion.div variants={textVariants}>
          <motion.div
            animate={{
              y: [0, -10, 0], // Moves up, then down
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              repeatType: "loop",
            }}
          >
            <FaArrowCircleUp className="icon" />
          </motion.div>
        </motion.div>
      </motion.div>
      <motion.div
        className="iframe-container"
        variants={iframeVariants}
        initial="hidden"
        animate="visible"
      >
        <iframe
          className="animation-iframe"
          // src="https://lottie.host/embed/865d62f6-6062-4389-b7fa-e62a44001188/gttqnm0y1R.json"
          src="https://lottie.host/embed/868c9089-c414-4fc0-be14-1ce8cdd38dfa/SWvslbhdyd.json"
          title="Lottie Animation"
        ></iframe>
      </motion.div>
    </div>
  );
};

export default PageNotFound;
